import { useCurrentBuilding } from '@/hooks/useCurrentBuilding';
import { useMemo } from 'react';

export const useFloorCategory = (selectedFloorName?: string) => {
    const { currentBuilding } = useCurrentBuilding();

    const selectedFloor = useMemo(() => {
        if (!currentBuilding || !selectedFloorName || !Array.isArray(currentBuilding?.floors)) {
            return null;
        }

        return currentBuilding.floors.find((floor) => floor.name.ko === selectedFloorName);
    }, [currentBuilding, selectedFloorName]);

    return {
        selectedFloor,
    };
};
